import * as React from 'react';
import theme from '../../utils/theme';
import { BaseForm } from './Base';

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface InputProps extends SelectProps {
  id: string;
  label: string;
  tooltip?: string;
  options: any[];
  field: any;
  onValueChange: Function;
  defaultValue: any;
  className?: string;
}

export interface Option {
  label: string;
  value: string;
}

export const Select = ({
  label,
  id,
  tooltip,
  options,
  field,
  onValueChange,
  className = '',
  ...rest
}: InputProps) => (
  <BaseForm label={label} id={id} tooltip={tooltip} className={className}>
    <select
      id={id}
      onChange={(e) => onValueChange(field, e.target.value)}
      className={theme.form.field.input}
      {...rest}
    >
      <option value={null}>Please select</option>
      {options.map((option: Option) => (
        <option value={option.value}>{option.label}</option>
      ))}
    </select>
  </BaseForm>
);

export default Select;
